<template>
  <div>
    <div class="login">
      <Row type="flex" justify="center" align="middle">
        <Col class="form">
        <h3>停车王需求管理系统</h3>
        <Form ref="loginForm" :model="loginForm" :rules="loginRule">
          <Form-item prop="user">
            <Input type="text" v-model="loginForm.user" placeholder="请输入用户名">
            <Icon type="ios-person-outline" slot="prepend"></Icon>
            </Input>
          </Form-item>
          <Form-item prop="password">
            <Input type="password" v-model="loginForm.password" placeholder="请输入密码">
            <Icon type="ios-locked-outline" slot="prepend"></Icon>
            </Input>
          </Form-item>
          <Form-item>
            <Checkbox v-model="loginForm.remember" style="float:left">记住密码</Checkbox>
            <Button type="primary" :loading="loginLoading" icon="log-in" style="float:right"
                    @click="loginPost('loginForm')">登录
            </Button>
          </Form-item>
        </Form>
        </Col>
      </Row>
    </div>
  </div>
</template>

<script>
  export default {
    data () {
      return {
        loginForm: {
          user: '',
          password: '',
          remember: true
        },
        loginRule: {
          user: [
            {required: true, message: '请填写用户名', trigger: 'blur'}
          ],
          password: [
            {required: true, message: '请填写密码', trigger: 'blur'},
            {type: 'string', min: 6, message: '密码长度不能小于6位', trigger: 'blur'}
          ]
        },
        loginLoading: false
      }
    },
    methods: {
      loginPost(name) {
          this.$router.push({name:'Index'})
      }
    }

  }
</script>




// WEBPACK FOOTER //
// Login.vue?252f64c1